import { render, staticRenderFns } from "./AppName.vue?vue&type=template&id=4d537625"
import script from "./AppName.vue?vue&type=script&lang=js"
export * from "./AppName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports